const FORMULA_TRIGGER_PATTERN = /^[=+\-@\t\r]/;

/** Whether a value would be read as a formula by Excel/Sheets when opened from a CSV. */
export function startsWithFormulaTrigger(value: string): boolean {
  return FORMULA_TRIGGER_PATTERN.test(value);
}

/** Prefixes a quote so Excel/Sheets show the cell as text instead of evaluating it. */
export function neutralizeCsvFormula(value: string): string {
  return startsWithFormulaTrigger(value) ? `'${value}` : value;
}
